import React, { FC, useContext } from 'react';

import { ScoreCard } from '../../match-entry/score-card/score-card';
import { MatchDayResultScoreCard, useFetchMatchDayResultScoreCard } from '../../../api/hooks/use-fetch-match-day-results-with-scorecard';

type ResultScoreCardProps = {
  tournamentIndex: number;
  dayIndex: number;
  matchIndex: number;
  format: 'Pairs' | 'Singles';
  startingHole: number;
};
export const ResultScoreCard: FC<ResultScoreCardProps> = ({ tournamentIndex, startingHole, dayIndex, matchIndex, format }): JSX.Element => {
  const { data } = useFetchMatchDayResultScoreCard(tournamentIndex, dayIndex);
  const { course, results } = data as MatchDayResultScoreCard;
  return <ScoreCard startingHole={startingHole} recordedMatch={results[matchIndex]} course={course} format={format} />;
};
